exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".X_DNKItGCyXyAHSv5eRfX{font-size:14px;color:var(--neutralSecondary)}.X_DNKItGCyXyAHSv5eRfX._3Q4hhHdpgxjSAaMGGCamMc{color:#c50e2e}._1y5MS5kz5SSlByPQkNP4LQ{font-size:12px;font-weight:400;color:var(--themePrimary);cursor:pointer}html[dir] ._1y5MS5kz5SSlByPQkNP4LQ{background:transparent}html[dir=ltr] ._3_7bNbSjS4vQ7MlmO4biDs{padding-right:5px}html[dir=rtl] ._3_7bNbSjS4vQ7MlmO4biDs{padding-left:5px}.AhxTbsnGIjkg8eXeFjL4n{position:relative;top:-1px}", ""]);
// Exports
exports.locals = {
	"sharingTipIcon": "X_DNKItGCyXyAHSv5eRfX",
	"error": "_3Q4hhHdpgxjSAaMGGCamMc",
	"actionButton": "_1y5MS5kz5SSlByPQkNP4LQ",
	"paddingRight": "_3_7bNbSjS4vQ7MlmO4biDs",
	"divider": "AhxTbsnGIjkg8eXeFjL4n"
};